function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.114)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M24.317,0A24.317,24.317,0,1,0,48.635,24.317,24.345,24.345,0,0,0,24.317,0ZM38.206,25.034l-9.119,9.119a1.013,1.013,0,0,1-1.73-.716V31.41a1.013,1.013,0,0,1,.3-.716L32,26.344H11.145a1.013,1.013,0,0,1-1.013-1.013V23.3a1.013,1.013,0,0,1,1.013-1.013H32l-4.35-4.35a1.012,1.012,0,0,1-.3-.716V15.2a1.013,1.013,0,0,1,1.73-.716L38.206,23.6A1.013,1.013,0,0,1,38.206,25.034Z",
  transform: "translate(0.114)"
}));

var SvgEnTransito = function SvgEnTransito(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.635,
    height: 48.635,
    viewBox: "0 0 48.635 48.635",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnTransito, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en-transito.ccbf8f42.svg";
export { ForwardRef as ReactComponent };